/* eslint-disable */
import { ErrorHelper } from '../../helpers/ErrorHelper';
import { mapState, mapActions } from 'vuex';
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const PetImagesCacheMixin = {
    mixins: [SelectedSiteIdMixin],
    data() {
        return {
            error: ''
        }
    },
    computed: {
        ...mapState('Client', [
            'client'
        ]),
        ...mapState('PetImages', [
            'petImages',
            'loadingPetImages',
            'retryPetImages'
        ])
    },
    watch: {
        selectedSiteId() {
            this.refreshPetImages();
        }
    },
    methods: {
        ...mapActions('PetImages', [
            'getPetImagesBySiteId'
        ]),
        refreshPetImages() {
            if (this.petImages.length == 0 || !!this.retryPetImages) {
                this.tryGetPetImagesBySiteId();
            }
        },
        tryGetPetImagesBySiteId() {
            const self = this;
            self.error = '';
            if(!self.selectedSiteId || !self.client) {
                return;
            }
            self.getPetImagesBySiteId(self.selectedSiteId)
                .catch(error => ErrorHelper.getError(error));
        }
    },
    created() {
        this.refreshPetImages();
    }
}
